import {
  SELF_GUIDED_TRIP_START,
  SELF_GUIDED_TRIP_SUCCESS,
  SELF_GUIDED_TRIP_ERROR,
  SELF_GUIDED_TRIP_LONG_RIDES_START,
  SELF_GUIDED_TRIP_LONG_RIDES_SUCCESS,
  SELF_GUIDED_TRIP_LONG_RIDES_ERROR,
  SELF_GUIDED_TRIP_TRAILS_START,
  SELF_GUIDED_TRIP_TRAILS_SUCCESS,
  SELF_GUIDED_TRIP_TRAILS_ERROR
} from "Constant/RentalCustomer";

const initialState = {
  loading: false,
  data: [],
  longRidesData: [],
  trailsData: []
};

export default function selfGuidedTripsReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case SELF_GUIDED_TRIP_START:
      return {
        ...state,
        loading: true,
      };
    case SELF_GUIDED_TRIP_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case SELF_GUIDED_TRIP_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case SELF_GUIDED_TRIP_LONG_RIDES_START:
      return {
        ...state,
        loading: true,
      };
    case SELF_GUIDED_TRIP_LONG_RIDES_SUCCESS:
      return {
        ...state,
        longRidesData: action.payload,
        loading: false,
      };
    case SELF_GUIDED_TRIP_LONG_RIDES_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case SELF_GUIDED_TRIP_TRAILS_START:
      return {
        ...state,
        loading: true,
      };
    case SELF_GUIDED_TRIP_TRAILS_SUCCESS:
      return {
        ...state,
        trailsData: action.payload,
        loading: false,
      };
    case SELF_GUIDED_TRIP_TRAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
